export const useNewPlanVar = process.env.NEXT_PUBLIC_FEATURES_2023_04_NEW_PLAN === 'true'
const useNewPlanUI = () => {
	// const [useNewPlan, setUseNewPlan] = useState<boolean>(false)
	// const router = useRouter()

	// useEffect(() => {
	// 	const { query } = router
	// 	const newPlan = query.useNewPlan
	//
	// 	if (newPlan === 'true') {
	// 		setUseNewPlan(true)
	// 	}
	// }, [router.query])
	//
	const useNewPlan = process.env.NEXT_PUBLIC_FEATURES_2023_04_NEW_PLAN === 'true'
	return { useNewPlan }
}

export default useNewPlanUI

export const useStudio = () => {
	// const [useStudio, setUseStudio] = useState<boolean>(false)
	// const router = useRouter()
	//
	// useEffect(() => {
	// 	const { query } = router
	// 	const newPlanStudio = query.useStudio
	//
	// 	if (newPlanStudio === 'true') {
	// 		setUseStudio(true)
	// 	}
	// }, [router.query])
	const useStudio = process.env.NEXT_PUBLIC_FEATURES_2023_04_STUDIO === 'true'
	return { useStudio }
}

export const usePurchaseCheck = () => {
	const usePurchaseCheck =
		process.env.NEXT_PUBLIC_FEATURES_2023_05_LICENSE_PURCHASE_CHECK === 'true'
	return { usePurchaseCheck }
}

export const useParsingBadge = () => {
	const useParsingBadge = process.env.NEXT_PUBLIC_FEATURES_2023_06_PARSING_BADGE === 'true'
	return { useParsingBadge }
}

export const useBuyStudio = () => {
	const useBuyStudio = process.env.NEXT_PUBLIC_FEATURES_2023_06_BUY_STUDIO === 'true'
	return { useBuyStudio }
}

export const ENV_NO_BASE_LICENSE_ID = () => {
	return { id: process.env.NEXT_PUBLIC_TEMP_SOURCE_ID }
}
